import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  adviceScreen: {
    minHeight: '100vh',
    padding: '20px 30px',
    color: theme.colors.light.ghostWhite,
    fontFamily: theme.fonts.family.primary,
    backgroundColor: theme.colors.dark.darkSlateBlue,
    position: 'relative',
  },
  sliderScreenContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  backButton: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'flex-start',
    textTransform: 'uppercase',
    fontSize: theme.fonts.sizes.captions,
  },
  title: {
    color: theme.colors.light.ghostWhite,
    fontFamily: 'inherit',
    fontSize: theme.fonts.sizes.titles,
    fontWeight: 100,
    textAlign: 'center',
  },
  cocktailList: {
    display: 'flex',
    margin: '0 auto',
    padding: '0 12px',
    flexDirection: 'column',
    alignItems: 'center',

    [theme.breakpoints.up('sm')]: {
      width: '50%',
    },
    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
  },
  cocktailListInner: {
    width: '100%',
  },
}));
